import Vue    from 'vue';
import Router from 'vue-router';
import store  from "@/store/store";
import $can   from "@/utils/abilities";
import apps   from "./apps";

Vue.use(Router);

const routes = [
  // ...require('@/router/routes/adminRoutes').default,
  // ...require('@/router/routes/superAdminRoutes').default,
  ...require('@/router/routes/housesImporterRoutes').default,
  ...require('@/router/routes/employeeRoutes').default,
  ...require('@/router/routes/commonRoutes').default,
];

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior( to, from, savedPosition ) {
    if (to.name !== from.name) return { x: 0, y: 0 };
  },
  routes,
});
// console.log({ router, store });

export const canAccessRoute = ( route ) => {
  const { meta } = route;
  if (!meta) return true;
  const { abilities, abilitiesRule, users, mcsIds } = meta;
  if (!abilities) return true;
  return $can(abilities, abilitiesRule, undefined, users, mcsIds);
};

// При смене дома в меню - проверить, что юзер имеет доступ к текущему роуту
store.watch(( state, getters ) => getters['appUser/selectedHouseId'], ( newVal, oldVal ) => {
  store.commit('SET_FORBIDDEN', !canAccessRoute(router.currentRoute));
});

store.watch(( state, getters ) => state.appUser.auth, ( newVal, oldVal ) => {
  if (oldVal && !newVal) window.location = '/auth/login';
});

router.beforeEach(async ( to, from, next ) => {
  // console.log(to);

  if (to.params.error404 || to.params.forbidden) return next();

  // Для авторизации из письма
  if (to.query.token) {
    localStorage.token = to.query.token;
    delete to.query.token;
    store.commit('appUser/UPDATE_TOKEN');
    await store.dispatch('appUser/GET_AUTH_USER');
    return next({ ...to });
  }

  // Проверить авторизацию, если еще не
  if (store.state.appUser.auth === null) await store.dispatch('appUser/GET_AUTH_USER');

  const userType = store.getters['appUser/type'];

  // Для неавторизованных юзеров редирект на авторизацию
  if (userType === null) {
    return window.location = '/auth/login';
  }

  // Если юзер открывет роут, предназначенный для другого типа, редиректнуть на нужный корень
  const url = apps[userType];
  if (url && to.path.indexOf(url) !== 0) return window.location = url;

  if (!canAccessRoute(to)) {
    store.commit('SET_FORBIDDEN', true);
    return next({ name: to.name, params: { ...to.params, forbidden: true }, query: to.query });
  }

  next();
});

// Если юзер уходит со страницы, то скрыть ошибки
router.afterEach(( to ) => {
  if (store.state.error404 && !to.params.error404) store.commit('SET_ERROR404', false);
  if (store.state.forbidden && !to.params.forbidden) store.commit('SET_FORBIDDEN', false);
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
